/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateCartRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {CreateCartResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const createCart = (request: CreateCartRequest, options?: CashRequestOptions) => post<CreateCartRequest, CreateCartResponse>("/cash-app/local/cart", request, {...options, rejectOnError: true })